export class ruolo {
    id?: number;
    nome_ruolo?: string;
}